
var page = 1;
infiniteLoadMore()

$('.gallery-page .load-more').on('click', function (e) {
    e.preventDefault()
    infiniteLoadMore()
})

async function infiniteLoadMore() {
    $('.gallery-page .loading-images').show()
    await $.ajax({
        url: '/csrf',
        method: 'get',
        dataType: 'text',
        async: false,
        success: function (response) {
            // set new token
            if (JSON.parse(response)) {
                $('meta[name="csrf-token"]').attr('content', JSON.parse(response).token);
            }
        }
    })

    await $.ajax({
        url: "/load-gallery?page=" + page,
        datatype: "html",
        type: "post",
        data: {
            _token: $('meta[name="csrf-token"]').attr('content')
        },
        beforeSend: function () {
            $('.load-more').show();
        }
    }).done(function (response) {
        if (response.length == 0) {
            $('.load-more').hide();
            return;
        }
        $("#data-wrapper").append(response);
    })

    page++;

    $('.gallery-page .loading-images').hide()
}